import type { TFunction } from 'i18next';
import { InitiativeStatus } from '../../../../api/initiative-client/initiative-client.type';
import { MilestoneState } from '../../../../api/milestones-client/milestones-client.type';

/**
 * Build the milestone state → display text map against the caller's
 * translation function so org-level text_config overrides apply.
 *
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns {Record<MilestoneState, string>} Milestone state label map
 */
const getMilestoneStateText = (t: TFunction): Record<MilestoneState, string> => ({
  [MilestoneState.COMPLETED]: t('common.completed'),
  [MilestoneState.IN_PROGRESS]: t('common.status.in_progress'),
  [MilestoneState.NOT_STARTED]: t('strategy.initiatives.statuses.not_started'),
  [MilestoneState.PAST_DUE]: t('strategy.milestones.past_due'),
  [MilestoneState.UNKNOWN]: t('strategy.initiatives.statuses.unknown'),
});

/**
 * Build the milestone status → display text map against the caller's
 * translation function so org-level text_config overrides apply.
 *
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns {Record<InitiativeStatus, string>} Milestone status label map
 */
const getMilestoneStatusText = (t: TFunction): Record<InitiativeStatus, string> => ({
  [InitiativeStatus.OnTrack]: t('strategy.initiatives.statuses.on_track'),
  [InitiativeStatus.AtRisk]: t('strategy.initiatives.statuses.at_risk'),
  [InitiativeStatus.OffTrack]: t('strategy.initiatives.statuses.off_track'),
  [InitiativeStatus.Unknown]: t('strategy.initiatives.statuses.unknown'),
  [InitiativeStatus.Empty]: t('strategy.initiatives.statuses.not_started'),
});

export { getMilestoneStateText, getMilestoneStatusText };
